import { useState } from 'react';
import './joinme.css';
import elbySignature from '../../assets/elby.png';
import penIcon from '../../assets/brush.png';
import { API_URL } from '../../config/api';

function JoinMe() {
  const [form, setForm] = useState({ name: '', email: '' });
  const [status, setStatus] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');
    try {
      const response = await fetch(`${API_URL}/subscribe/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name || 'Friend', // fallback since name is optional here
          email: form.email,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setStatus("🎉 You're in! Talk soon.");
        setForm({ name: '', email: '' });
        setSubmitted(true);
      } else {
        setStatus('Failed to subscribe. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setStatus('Error connecting to server.');
    }
  };

  return (
    <section className="joinme-section">
      <div className="joinme-centered-box">
        <h2 className="newsletter-heading">Subscribe to Letters from</h2>
        <img src={elbySignature} alt="Elby Signature" className="elby-logo-centered" />
        <p className="newsletter-description">
          A soft letter every few weeks — a quiet pause filled with thoughts, books, and gentle reminders to come back to yourself. <br />
          <em>A moment of calm, from me to you.</em>
        </p>

        {!submitted ? (
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your name (optional)"
              value={form.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Your email address"
              value={form.email}
              onChange={handleChange}
              required
            />
            <button type="submit">
              {status === 'Sending...' ? 'Sending...' : 'Join the Newsletter'}
            </button>
            {status && !submitted && (
              <p className="newsletter-error">{status}</p>
            )}
          </form>
        ) : (
          <p className="newsletter-success">{status}</p>
        )}

        <p className="newsletter-note">
          You can unsubscribe anytime. Your inbox is safe with me. ✨
        </p>
        <img src={penIcon} alt="Pen Icon" className="bottom-pen-icon" />
      </div>
    </section>
  );
}

export default JoinMe;